import React from 'react';
import PropTypes from 'prop-types';
import { AREA_OPTIONS_MIN, AREA_OPTIONS_MAX} from '../../constants/filterOptions';
import {
    validateCharactersWithComma,
    validateDecimalPlaces,
    validateMaxLength
} from 'lib/Validations';
import useFilterStore from '../../zustandStore/useFilterStore';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import RpRangeWithUnitFilter from 'components/commons/RpRangeWithUnitFilter';

const RangeSelectArea = React.memo(function RangeSelectArea(props) {
    const filters = useFilterStore(state => state.filters[props.comparableType]?.[props.attrName]);
    const setFilters = useFilterStore(state => state.setFilters);
    const errors = useFilterStore(state => state.errors[props.comparableType]);
    const setError = useFilterStore(state => state.setError);
    const removeError = useFilterStore(state => state.removeError);
    const minOptions = props.minOptions || AREA_OPTIONS_MIN;
    const maxOptions = props.maxOptions || AREA_OPTIONS_MAX;

    const minValue = filters?.min ? SearchFilterUtil.findOptionByValue(minOptions, filters.min) : { value: '', label: 'Min' };
    const maxValue = filters?.max ? SearchFilterUtil.findOptionByValue(maxOptions, filters.max) : { value: '', label: 'Max' };

    const validateInput = (input) => {
        return (
            validateCharactersWithComma(input) ||
            validateMaxLength(input) ||
            validateDecimalPlaces(input)
        );
    };

    const onError = (error) => {
        if (Boolean(error.length)) {
            setError(props.comparableType, props.attrName);
        } else {
            removeError(props.comparableType, props.attrName);
        }
    };

    return (
        <RpRangeWithUnitFilter
            label={props.label}
            active={minValue.value !== '' || maxValue.value !== ''}
            error={errors.includes(props.attrName)}
            subLabel="Select an option or manually enter a value"
            minOptions={minOptions}
            maxOptions={maxOptions}
            minValue={minValue}
            maxValue={maxValue}
            unitValue={filters?.unit}
            onChange={({ min, max, unit }) => setFilters(props.comparableType, { [props.attrName]: { min: min.value, max: max.value, unit } })}
            validateInput={validateInput}
            isDropdown={false}
            onError={onError}
            sx={props.sx}
        />
    );
});

RangeSelectArea.propTypes = {
    comparableType: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    attrName: PropTypes.string.isRequired,
    sx: PropTypes.object,
};

export default RangeSelectArea;
